// Événements du club (D-034) : libellés et places.

export type ClubEventKind = 'tournoi' | 'loto' | 'ag' | 'stage' | 'soiree' | 'vide_grenier' | 'autre';
export type SignupMode = 'none' | 'members' | 'public';

export const EVENT_KIND_LABEL: Record<ClubEventKind, string> = {
  tournoi: 'Tournoi', loto: 'Loto', ag: 'Assemblée générale', stage: 'Stage', soiree: 'Soirée', vide_grenier: 'Vide-grenier', autre: 'Événement',
};
export const SIGNUP_LABEL: Record<SignupMode, string> = { none: 'Sans inscription', members: 'Membres du club', public: 'Ouvert au public' };

/** Places restantes (null : pas de limite). */
export const placesLeft = (capacity: number | null, taken: number) => (capacity == null ? null : Math.max(0, capacity - taken));

/** « 12 inscrits », « 12 inscrits · 3 places », « complet ». */
export function placesLabel(capacity: number | null, taken: number): string {
  const left = placesLeft(capacity, taken);
  const who = `${taken} ${taken > 1 ? 'inscrits' : 'inscrit'}`;
  if (left == null) return who;
  if (left === 0) return `${who} · complet`;
  return `${who} · ${left} ${left > 1 ? 'places' : 'place'}`;
}
